import image1 from "../images/navbar/TOP_01.png";
import image2 from "../images/navbar/TOP_02.png";
import image3 from "../images/navbar/TOP_03.png";
import image4 from "../images/navbar/TOP_04.png";

const previewCourses = [
    {
        backgroundImage: image1,
        number: "01",
        course: "Escuela ZBrush ",
        url:"https://libel.academy/escuela-zbrush/"
    },
    {
        backgroundImage: image2,
        number: "02",
        course: "Crea y Anima Personajes",
        url: "https://libel.academy/vacacional-blender/"
    },
    {
        backgroundImage: image3,
        number: "03",
        course: "Escultura para principiantes",
        url:"https://libel.academy/zbrush-desde-cero/"
    },
    {
        backgroundImage: image4,
        number: "04",
        course: "Aprende 3D Gratis",
        url:"https://libel.academy/libel-up/"
    },
];

export default previewCourses;
